import React from 'react';
export function HeroSection() {
  return <section className="relative pt-6 pb-8 md:pt-24 md:pb-28 overflow-hidden px-4 sm:px-6 lg:px-8" style={{
    contain: 'layout style'
  }} data-id="element-121">
      {/* Background glow — hidden on mobile to reduce GPU compositing */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[500px] bg-purple-600/10 blur-[80px] md:blur-[120px] rounded-full pointer-events-none hidden md:block md:max-w-5xl md:h-[700px] md:bg-purple-600/15" data-id="element-122" />
      <div className="absolute top-40 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[400px] bg-blue-600/10 blur-[100px] rounded-full pointer-events-none hidden md:block" data-id="element-123" />

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-124">
        {/* Brand Tag */}
        <div className="hero-animate-1 inline-flex items-center gap-2 px-4 py-1.5 md:px-5 md:py-2 rounded-full bg-purple-500/10 border border-purple-500/30 text-purple-300 font-semibold text-xs md:text-sm tracking-widest mb-4 md:mb-8 uppercase shadow-[0_0_15px_rgba(168,85,247,0.15)]" data-id="element-125">
          👨‍👩‍👧‍👦 PACK 100 CITAS
        </div>

        {/* Main Headline */}
        <h1 className="hero-animate-2 text-3xl sm:text-5xl md:text-7xl lg:text-8xl font-extrabold leading-[1.08] tracking-tight mb-2 md:mb-4 text-white" data-id="element-126">
          "Un día tu hijo va a dejar de pedirte tiempo…"{' '}
          <span className="text-gradient-cosmic" data-id="element-127">
            Y cuando eso pase… ya no vuelve.
          </span>
        </h1>

        {/* Accent Subheadline */}
        <p className="hero-animate-2 text-2xl sm:text-4xl md:text-6xl lg:text-7xl font-extrabold text-purple-400 mb-6 md:mb-12" data-id="element-128">
          Jugá. Conectá. Recordá.
        </p>

        {/* Product Image */}
        <div className="relative max-w-xs md:max-w-2xl mx-auto mb-6 md:mb-12" data-id="element-129">
          {/* Glow behind image — hidden on mobile for GPU savings */}
          <div className="absolute inset-0 bg-gradient-to-tr from-purple-600/15 via-blue-500/10 to-gold-500/5 blur-2xl md:blur-3xl rounded-full scale-110 hidden md:block" data-id="element-130" />
          <img src="https://cdn.magicpatterns.com/uploads/iLBMd7eg2Hf522DhHgUy5m/pasted-image.jpg" alt="Pack 100 Citas Familiares" className="relative z-10 w-full max-w-[540px] mx-auto h-auto drop-shadow-lg md:drop-shadow-2xl object-contain" width={1080} height={1080} sizes="(max-width: 320px) 280px, (max-width: 768px) 320px, 540px" loading="eager" decoding="async" fetchPriority="high" data-id="element-131" />
        </div>

        {/* Product Description */}
        <div className="hero-animate-3 max-w-3xl mx-auto mb-6 md:mb-10" data-id="element-132">
          <h2 className="text-base md:text-2xl font-bold text-purple-300 mb-2 md:mb-3" data-id="element-133">
            Descubre el Pack 100 Citas 👨‍👩‍👧‍👦 y vive experiencias únicas con tus
            hijos y toda la familia.
          </h2>
          <p className="text-sm md:text-lg text-slate-400 leading-relaxed" data-id="element-134">
            Cada cita 💫 es un momento especial que fortalece los lazos,
            despierta sonrisas y crea recuerdos para siempre ❤️
          </p>
        </div>

        {/* Trust Badges */}
        <div className="hero-animate-4 flex flex-wrap items-center justify-center gap-1.5 md:gap-3 mb-6 md:mb-10" data-id="element-135">
          {[{
          emoji: '📚',
          label: '4 Libros digitales'
        }, {
          emoji: '⚡',
          label: 'Descarga inmediata'
        }, {
          emoji: '🎁',
          label: '7 Bonos incluidos'
        }, {
          emoji: '💫',
          label: '+500 ideas'
        }].map((badge, i) => <span key={i} className="inline-flex items-center gap-1.5 md:gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-navy-800 border border-navy-700 text-xs md:text-sm font-medium text-slate-300" data-id="element-136">
              <span data-id="element-137">{badge.emoji}</span>
              {badge.label}
            </span>)}
        </div>

        {/* CTA Button */}
        <div className="hero-animate-5 flex flex-col items-center w-full md:w-auto" data-id="element-138">
          <button onClick={() => {
          const scrollToPricing = () => {
            const el = document.getElementById('pricing');
            if (el) {
              el.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
              // Re-scroll after layout settles (content-visibility sections)
              setTimeout(() => {
                el.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
              }, 600);
            }
          };
          scrollToPricing();
        }} className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white font-bold text-sm md:text-lg py-3 px-6 md:py-4 md:px-10 rounded-full shadow-[0_0_25px_rgba(168,85,247,0.35)] transition-all transform hover:scale-[1.03] flex items-center justify-center gap-2 w-full md:w-auto border border-purple-400/30" data-id="element-139">
            👉 Hoy todavía estás a tiempo.
          </button>

          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-5 mt-4 md:mt-5 text-[10px] md:text-sm text-slate-500" data-id="element-140">
            <span data-id="element-141">🛡️ Garantía 7 días</span>
            <span className="text-slate-700" data-id="element-142">•</span>
            <span data-id="element-143">🔒 Pago seguro</span>
            <span className="text-slate-700" data-id="element-144">•</span>
            <span data-id="element-145">💳 Tarjeta | Débito | Crédito</span>
          </div>
          <p className="mt-3 text-[10px] md:text-xs text-purple-400/70 font-medium" data-id="element-146">
            🌎 Pagalo en tu moneda local
          </p>
        </div>
      </div>
    </section>;
}